import React from "react";
import { useState } from "react";
import ReactSelect from "react-select";
import Common from "../Common";
import CustomOption from "./CustomOption";

class SelectCellEditor extends Common {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      options: this.props.colDef.options,
    };
  }

  getValue = () => {
    return this.state.value;
  };

  // any cleanup we need to be done here
  destroy = () => {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
  };

  // if true, then this editor will appear in a popup
  isPopup = () => {
    // and we could leave this method out also, false is the default
    return false;
  };
  componentDidMount() {
    this.setState((state) => {
      return {
        ...state,
        value: this.props?.value?.value || this.props?.value,
      };
    });
    this.focusInput();
  }

  focusInput = () => {
    setTimeout(() => {
      if (this.selectRef) {
        this.selectRef.focus();
      }
    }, 0);
  };
  handleChange = (selectedOption) => {
    this.setState(
      (state) => {
        if (Array.isArray(selectedOption)) {
          return {
            ...state,
            value: selectedOption.map((item) => item.value),
          };
        } else {
          return {
            ...state,
            value: selectedOption.value,
          };
        }
      },
      () => {
        this.props.api.stopEditing(); // Stop editing the cell
        this.props.api.applyTransaction({
          update: [{ ...this.props.node.data, column: selectedOption.value }],
        }); // Update the data source
        this.props.api.refreshCells({ rowNodes: [this.props.node] }); // Refresh the grid to reflect the updated data
      }
    );
  };
  render() {
    let newoptions = [];
    if (this.state.options && !Array.isArray(this.state.options)) {
      newoptions = Object.keys(this.state.options).map((item) => ({
        label: this.state.options[item].option_name,
        value: this.state.options[item]._id,
      }));
    } else {
      newoptions = this.state.options.map((item) => ({
        label: item.option_name,
        value: item._id,
      }));
    }

    let newvalues;
    if (Array.isArray(this.state.value)) {
      newvalues = newoptions.filter((item) =>
        this.state.value.includes(item.value)
      );
    } else {
      newvalues = newoptions.filter((item) => item.value === this.state.value);
    }

    const menuPortalTarget = document.body;
    return (
      <ReactSelect
        menuIsOpen={true}
        value={newvalues}
        options={newoptions}
        className={
          newvalues?.length > 3 ? "assignClass isLarge" : "assignClass"
        }
        onChange={this.handleChange}
        isMulti={this.props.colDef.is_multiple || this.props.isMulti}
        menuPortalTarget={menuPortalTarget}
        styles={{
          zIndex: 999999,
          width: "100%",
          control: (provided) => ({ ...provided, width: "100%" }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            width: this.props.colDef.width,
          }),
          control: (styles, state) => {
            return {
              ...styles,
              fontSize: "12px",
              textAlign: "left",
              boxShadow: "none",
              width: "100%",
              height: 50,
              overflowY: "auto",
            };
          },

          multiValueLabel: (provided) => ({
            ...provided,
            // color: "#fff", // Text color of the selected value
            // fontWeight: "bold",
          }),

          menuList: (provided) => ({
            ...provided,
            width: this.props.colDef.width,
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        menuPlacement="auto"
        ref={(ref) => (this.selectRef = ref)}
      />
    );
  }
}

export default SelectCellEditor;
